import { AddressAddressee } from './address-addressee';

export interface AddressDetails {
  id: string;
  addressee: string;
  name: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  townCity: string;
  region: string;
  postCode: string;
  countryId: string;
  phone: string;
  email: string;
  salesRegionId: string;
  salesDiscountId: string;
  contactAgreementId: string;
  customerTypeId: string;
  customerSubTypeId: string;
  notes: string;
  webAddress: boolean;
  vatRegNo: string;
  obsolete: boolean;
  accountNo: string;
  childAccountNumber: string;
  eoriNumber: string;
  deliveryTermId: string;
  multiLine: string;

  addressAddressee: AddressAddressee[];
}
